import { render, staticRenderFns } from "./BbForm.vue.html?vue&type=template&id=753d3922&scoped=true&"
import script from "./BbForm.component.js?vue&type=script&lang=vueJs&"
export * from "./BbForm.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BbForm.scoped.scss?vue&type=style&index=0&id=753d3922&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d3922",
  null
  
)

export default component.exports